/*
 * ॐ नमः शिवाय
 *
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * This software is licensed under the VIJAYA 1.0 License.
 *
 * You are free to use, modify, and distribute this software under the terms 
 * of the VIJAYA 1.0 License.
 *
 * MANDATORY ATTRIBUTION:
 * 1. The attribution to Rudra Coresoft Technologies Private Limited in this 
 *    copyright notice must not be removed even after modifications.
 * 2. For Free License usage, the footer phrases "Powered by arcee.io" and 
 *    "Developed by Rudra Coresoft" (plus logos) must remain visible.
 *
 * See the LICENSE file for the full text.
 */

import React from "react";
import { useTheme } from "../../theme/ThemeContext";

export default function ThemedInput({ error, style, ...props }) {
    const { theme } = useTheme();

    const baseStyle = {
        border: `1.4px solid ${error ? "#d53b3b" : theme.primary}`,
        borderRadius: theme.buttonRadius,
        background: "#f8fafc",
        color: theme.text,
        fontFamily: "inherit",
        width: "100%",
        padding: "8px 11px",
        outline: "none",
    };

    // Extra styling when disabled
    const disabledStyle = props.disabled
        ? {
            background: "#cdd0d6ff",
            color: "#66676bff",
        }
        : {};

    return (
        <input
            {...props}
            style={{
                ...baseStyle,
                ...disabledStyle,
                ...(style || {}),
            }}
            className={props.className}
        />
    );
}
